// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.personal-details-container {
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 105.3125rem;
  background: #f5f5f5;
}
.personal-details-title {
  display: flex;
  height: 90px;
  padding: 2%;
  align-items: center;
  flex-shrink: 0;
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Montserrat;
  font-size: var(--Font-Font-Size-h5, 19px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-bottom: 1px solid #d2d2d2;
}
.profile-image-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5%;
}
.profile-image-upload-buttons-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5%;
  margin-top: 5%;
}
.upfront-percentage-col {
  display: flex;
  justify-content: space-between;
}
.buyer-contents-menu-card-row {
  margin-left: 4%;
}

.buyer-contents-menu-card {
  display: flex;
  padding: 32px 21px 607px 21px;
  flex-direction: column;
  align-items: flex-start;
  gap: 11px;
  flex-shrink: 0;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}

.buyer-contents-menu {
  display: flex;
  height: 60px;
  padding: 14px 33px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 10px;
  width: 100%;
}

.buyer-contents-menu-name {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 100% !important;
  cursor: pointer;
  font-size: 16px !important;
}

.buyer-contents-menu .ant-menu-item:hover,
.buyer-contents-menu .ant-menu-item-selected {
  background-color: transparent !important;
  color: inherit !important;
  cursor: default !important;
  border-left: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}
.buyer-contents-menu-card-row .ant-col-6 {
  max-width: 25% !important;
}
.personal-information-main-heading-div {
  margin-top: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.personal-information-main-heading {
  color: #000;
  font-family: Montserrat;
  font-size: var(--Font-Font-Size-h4, 17px) !important;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  justify-content: center;
}
.avatar-col {
  display: flex;
  justify-content: center;
  align-items: center;
}
.floating-avatar {
  display: flex;
  height: 5rem;
  padding: 2.6875rem 1.625rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-radius: 6.25rem;
  background: #fff;
  box-shadow: 2px 2px 20px 0px rgba(0, 0, 0, 0.16);
}
.your-details-text {
  font-family: Roboto;
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.upload-new-photo-card {
  width: 100%;
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  margin-top: 5%;
  display: flex;
  align-items: center;
  padding: 20px;
}

.card-tittle {
  font-family: Roboto;
}

.image-card-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 8rem;
}

.profile-image-section {
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #e0e0e0;
}
.buyer-content-details {
  margin-left: 4% !important;
  position: sticky;
  overflow-y: auto;
  max-height: 78vh;
}
.profile-image {
  width: 7rem !important;
  height: 7rem !important;
  flex-shrink: 0;
}

.upload-photo-content {
  display: flex;
  width: 100%;
  /* margin-bottom: 2rem !important; */
}

.sample-parent .ant-upload-wrapper .ant-upload-select {
  margin-bottom: 0.5rem;
}
.profile-delete-text {
  font-family: Roboto;
  color: #d2042d;
  font-family: Roboto;
  font-weight: 400;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  cursor: pointer;
  margin-top: 10px;
}
.profile-image-section-remove {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.upload-instruction {
  margin-top: 8px;
  color: #9e9e9e;
  font-size: 14px;
}

.sample-parent .ant-btn-icon {
  display: none !important;
}

.parent-ant-button
  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
  background: transparent !important;
  color: inherit !important;
  border-color: inherit !important;
}

.upload-profile-and-text {
  display: flex;
  flex-direction: column;
}

.upload-below-text {
  font-family: Roboto;
  color: var(--Colors-Text-200, #8e9190);
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.profile-upload-btn {
  font-family: Roboto;
  display: flex;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  background: #f5f5f5;
}

.upload-btn-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.personal-details-card {
  padding: 2rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  margin-top: 4%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.card-header h3 {
  font-weight: bold;
}

.edit-button {
  font-family: Roboto;
  color: #d2042d;
  border: none;
  background: transparent;
}
.edit-button:hover,
.edit-button:active,
.edit-button:active {
  border: none !important;
  box-shadow: none !important;
  background-color: none !important;
}

.details-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.details-row {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 8px;
}

.details-row-div {
  display: flex;
  padding-bottom: 1.5rem;
  justify-content: space-between;
  align-items: center;
}

.details-row-headers {
  font-family: Roboto;
  color: var(--Colors-Text-200, #8e9190);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
}

.details-row-text {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
}
.account-type-logo-col {
  display: flex;
  align-items: center;
}
.details-row-text:hover {
  color: var(--Colors-Text-500, #0a0f0d) !important;
}
.contact-information-card {
  padding: 2rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  margin-top: 4%;
}

.address-card {
  margin-top: 4%;
  padding: 2rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}

.account-information-card {
  margin-top: 4%;
  padding: 1rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}

.account-row-headers {
  font-family: Roboto;
  color: var(--Colors-Text-200, #8e9190);
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
}
.website-url {
  color: var(--Colors-Primary-500, #d2042d) !important;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.membership-status-card {
  margin-top: 4%;
  padding: 2rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}

.memebership-status-value {
  color: #28a745;
  text-align: right;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
}

.subscription-plan-card {
  margin-top: 4%;
  padding: 2rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  display: none;
}

.subscription-plan-head {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h6, 1.1875rem);
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem;
}

.manage-subscription-link-container {
  display: contents;
  justify-content: center;
  justify-items: center;
}

.manage-subscription-link {
  font-family: Roboto;
  color: var(--Colors-Primary-500, #d2042d) !important;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.security-settings-head {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h6, 1.1875rem);
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem;
}

.account-recovery-card {
  margin-top: 4%;
  padding: 2rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}

.account-recovery-head {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h6, 1.1875rem);
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem;
}

.notification-preference-card {
  margin-top: 4%;
  padding: 2rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}
.settings-preference-head {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h6, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem;
}
.payment-methods-card {
  margin-top: 4%;
  padding: 2rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}
.payment-methods-head {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h6, 1.1875rem);
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem;
}
.payment-download-text {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
}
.help-support-card {
  margin-top: 4%;
  padding: 2rem;
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}
.payment-methods-head {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h6, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem;
}
.access-faq-btn-text {
  font-family: Roboto;
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.details-cancel-btn {
  display: flex;
  padding: 0.5rem 1.25rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  background: #eee;
}
.details-cancel-btn-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.details-save-btn {
  display: flex;
  padding: 0.5rem 1.25rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  background: #d2042d;
}
.details-save-btn-text {
  color: #fff;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.profile-upload-cancel-btn {
  display: flex;
  padding: 0.5rem 1.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  background: #e0e0e0;
}
.profile-upload-cancel-btn-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.personal-details-col {
  display: flex;
  flex-direction: column;
  width: 50% !important;
}
.profile-upload-save-btn {
  display: flex;
  padding: 0.5rem 1.25rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  background: #d2042d;
}
.profile-upload-save-btn:hover {
  background: #d2042d !important;
}
.profile-upload-save-btn-text {
  color: #fff;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.terms-setup-card,
.upfront-payment-card {
  margin-top: 2.125rem;
}
.default-terms {
  font-family: Roboto;
  font-size: 1rem;
  font-weight: 400;
  margin-top: 2.125rem;
}
.navigate-to-terms {
  margin-top: 0.5rem;
}
.default-terms-link {
  font-family: Roboto;
  text-decoration: underline;
  color: #d2042d;
  font-size: 1rem;
  font-weight: 400;
  margin-top: 0.5rem;
}
.edit-label {
  font-family: Roboto;
  color: #d2042d;
  font-size: 1rem;
  cursor: pointer;
  margin-left: 0.2rem;
  position: relative;
  bottom: 0.2rem;
}
.edit-icon {
  height: 24px;
  cursor: pointer;
  margin-left: 1.2rem;
}
.upfront-percent {
  font-family: Roboto;
  font-weight: 500;
  font-size: 1rem;
  padding-left: 0.8rem;
}
.percent-symbol {
  font-family: Roboto;
  top: 1rem;
  position: relative;
  font-size: 1rem;
  font-weight: 700;
}
.upfront-cancel-btn,
.upfront-save-btn {
  font-weight: 500;
  border: none;
}
.upfront-cancel-btn {
  background: #e5e5e5 !important;
  color: #000 !important;
}
.upfront-save-btn {
  color: #fff !important;
  background-color: #d2042d !important;
}

.personal-details-avatar {
  background: #d2042d;
  color: #fff;
}

.profile-edit-btn {
  display: flex;
  gap: 0.5rem;
}
.my-billboard-datepicker
  ~ .ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-today
  .ant-picker-cell-inner::before {
  border: 1px solid #d2042d !important;
}
.my-billboard-datepicker.ant-picker-outlined:hover {
  border-color: #000 !important;
}
.personal-details-buttons-row {
  display: flex;
  margin-top: 1rem;
  gap: 0.5rem;
  justify-content: flex-end;
}
.remove-profile-picture {
  font-family: Roboto;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000;
}
.remove-profile-buttons-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: nowrap;
  align-items: center;
  gap: 20px;
}
.confirmation-remove-profile-row {
  margin-top: 10px;
}
.confirmation-remove-profile-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--Colors-Text-400, #3b3f3d);
}
.remove-profile-button {
  height: 35px !important;
  background-color: #d2042d !important;
}
.remove-profile-button-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #fff;
}
.remove-profile-button:hover {
  background-color: #d2042d !important;
}
.profile-delete-cancel-button {
  height: 35px !important;
  background: #e0e0e0;
}
.profile-delete-cancel-button:hover {
  background: #e0e0e0 !important;
}
.profile-delete-cancel-button-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000;
}
.details-label-col {
  width: 50%;
}
@media (max-width: 1024px) {
  .buyer-content-details {
    margin-left: 4% !important;
    position: sticky;
    overflow-y: scroll;
    max-height: 82vh;
  }
  .buyer-contents-menu-card-row {
    gap: 4% !important;
  }
}
@media (max-width: 1440px) {
  .buyer-content-details {
    margin-left: 4% !important;
    position: sticky;
    overflow-y: scroll;
    max-height: 75vh;
  }
  .buyer-contents-menu-card-row {
    gap: 4% !important;
  }
}

@media (min-width: 321px) and (max-width: 375px) {
  .upload-new-photo-card {
    width: 90%;
    margin-left: 17px;
  }
  .personal-details-card {
    width: 90%;
    margin-left: 17px;
  }
  .contact-information-card {
    width: 90%;
    margin-left: 17px;
  }
  .address-card {
    width: 90%;
    margin-left: 17px;
  }
  .back-button {
    font-size: 12px;
    padding: 5px 10px;
    width: auto;
  }
  .personal-details-col {
    overflow-x: scroll !important;
  }
  .details-row-text {
    font-size: 0.9rem !important;
  }
  .personal-information-main-heading {
    color: #000;
    font-family: Montserrat;
    font-size: var(--Font-Font-Size-h4, 20px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    justify-content: center;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .account-information-card {
    width: 90%;
    margin-left: 17px;
  }
  .membership-status-card {
    width: 90%;
    margin-left: 17px;
  }
  .account-row-headers {
    font-size: 0.9rem;
  }
  .details-row-headers {
    font-family: Roboto;
    color: var(--Colors-Text-200, #8e9190);
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;
  }
  .account-recovery-card {
    width: 90%;
    margin-left: 17px;
  }
  .notification-preference-card {
    width: 90%;
    margin-left: 17px;
  }
  .help-support-card {
    width: 90%;
    margin-left: 17px;
  }
  .terms-setup-card,
  .upfront-payment-card {
    width: 90%;
    margin-left: 17px;
  }
}

@media (min-width: 376px) and (max-width: 425px) {
  .personal-information-main-heading {
    color: #000;
    font-family: Montserrat;
    font-size: var(--Font-Font-Size-h4, 20px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    justify-content: center;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .upload-new-photo-card {
    width: 90%;
    margin-left: 20px;
  }
  .personal-details-card {
    width: 90%;
    margin-left: 20px;
  }
  .contact-information-card {
    width: 90%;
    margin-left: 20px;
  }
  .address-card {
    width: 90%;
    margin-left: 20px;
  }
  .account-information-card {
    width: 90%;
    margin-left: 20px;
  }
  .membership-status-card {
    width: 90% !important;
    margin-left: 20px !important;
  }
  .account-recovery-card {
    width: 90%;
    margin-left: 20px;
  }
  .notification-preference-card {
    width: 90%;
    margin-left: 20px;
  }
  .help-support-card {
    width: 90%;
    margin-left: 20px;
  }
  .back-button {
    font-size: 12px;
    padding: 5px 10px;
    width: auto;
  }
  .terms-setup-card,
  .upfront-payment-card {
    width: 90%;
    margin-left: 17px;
  }
  .personal-details-col {
    overflow-x: scroll;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .upload-new-photo-card {
    width: 90%;
    margin-left: 35px;
  }
  .personal-information-main-heading {
    color: #000;
    font-family: Montserrat;
    font-size: var(--Font-Font-Size-h4, 23px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    justify-content: center;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .personal-details-card {
    width: 90%;
    margin-left: 35px;
  }
  .contact-information-card {
    width: 90%;
    margin-left: 35px;
  }
  .address-card {
    width: 90%;
    margin-left: 35px;
  }
  .account-information-card {
    width: 90%;
    margin-left: 35px;
  }
  .membership-status-card {
    width: 90% !important;
    margin-left: 35px !important;
  }
  .account-recovery-card {
    width: 90%;
    margin-left: 35px;
  }
  .notification-preference-card {
    width: 90%;
    margin-left: 35px;
  }
  .help-support-card {
    width: 90%;
    margin-left: 35px;
  }
  .back-button {
    font-size: 17px;
    padding: 2px 10px;
    width: auto;
  }
  .terms-setup-card,
  .upfront-payment-card {
    width: 90% !important;
    margin-left: 35px !important;
  }
}
@media (min-width: 320px) and (max-width: 844px) {
  .buyer-contents-menu-card-row {
    margin: 0px !important;
    width: 100%;
    overflow-y: scroll;
    max-height: 100%;
  }

  .buyer-content-details {
    margin: 0 !important;
    padding: 1.1rem !important;
    max-height: 100%;
  }
  .personal-details-container {
    height: 100% !important;
    /* position: fixed; */
    overflow-y: scroll;
  }

  .buyer-contents-menu {
    display: flex;
    width: 100%;
    padding: 0.5rem 1.25rem;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
    border-radius: 0.625rem;
    background: #fff;
    box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
  }
  .buyer-contents-menu-name {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .buyer-contents-menu-card {
    display: flex;
    /* padding: 0px 21px 607px 21px; */
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem !important;
    flex-shrink: 0;
    background: none;
    box-shadow: none;
  }
  .personal-details-title {
    height: 0px;
    border-bottom: none;
    margin-bottom: 1rem !important;
    padding: 0 !important;
  }
  .personal-information-main-heading-div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
}
@media (min-width: 0px) and (max-width: 320px) {
  .buyer-content-details {
    position: sticky;
  }
  .profile-image {
    width: 5rem !important;
    height: 5rem !important;
  }
  .profile-upload-btn {
    height: 2rem !important;
  }
  .upload-btn-text {
    font-size: 13px !important;
  }
  .profile-delete-text {
    font-size: 11px !important;
  }
  .details-row-text {
    font-size: 0.9rem !important;
  }

  .upload-new-photo-card {
    width: 90%;
    border-radius: 10px;
    background: #fff;
    box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
    margin-top: 5%;
    display: flex;
    align-items: center;
    padding: 20px;
    margin-left: 1rem;
  }
  .personal-details-card {
    width: 90%;
    margin-left: 1rem;
    padding: 1rem;
  }
  .account-recovery-card {
    width: 90%;
    margin-left: 1rem;
  }
  .contact-information-card {
    width: 90%;
    margin-left: 1rem;
    padding: 1rem;
  }
  .address-card {
    width: 90%;
    margin-left: 1rem;
    padding: 1rem;
  }
  .back-button {
    font-size: 12px;
    padding: 5px 10px;
    width: auto;
  }
  .terms-setup-card,
  .upfront-payment-card {
    margin-top: 2.125rem;
    width: 90%;
    margin-left: 1rem;
  }
  .personal-information-main-heading {
    color: #000;
    font-family: Montserrat;
    font-size: var(--Font-Font-Size-h4, 20px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    justify-content: center;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .personal-information-main-heading-div {
    margin-top: 5%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-content: stretch;
    align-items: flex-start;
    margin-inline-start: 10px !important;
  }
  .card-tittle {
    font-family: Roboto;
    color: var(--Colors-Text-500, #0a0f0d);
    font-family: Roboto;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 550;
    line-height: normal;
  }
  .details-row-headers {
    color: var(--Colors-Text-200, #8e9190);
    font-size: 0.8rem !important;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;
  }
  .personal-details-col {
    width: 50% !important;
    overflow-x: scroll !important;
  }
  .details-row-text {
    color: var(--Colors-Text-500, #0a0f0d);
    text-align: right;
    font-size: 0.8rem !important;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;
  }
  .website-url {
    font-size: 0.9rem;
  }
  .account-information-card {
    width: 90%;
    margin-left: 15px;
    padding: 1rem;
  }
  .membership-status-card {
    width: 90%;
    margin-left: 15px;
    padding: 1rem;
  }
  .notification-preference-card {
    width: 90%;
    margin-left: 15px;
    padding: 1rem;
  }
  .account-row-headers {
    font-size: 0.9rem;
  }
  .your-details-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .swith-button .ant-switch {
    transform: scale(0.6);
  }
  .security-settings-head {
    font-size: 18px;
    font-weight: 600px;
  }
  .manage-subscription-link {
    font-size: 14px;
  }
  .account-recovery-head {
    font-size: 18px;
    font-weight: 600px;
  }
  .settings-preference-head {
    font-size: 18px;
    font-weight: 600px;
  }
  .help-support-card {
    width: 90%;
    margin-left: 15px;
    padding: 1rem;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .personal-information-main-heading-div {
    margin-inline-start: 28px !important;
  }
}
@media (max-width: 768px) {
  .personal-information-main-heading {
    font-family: Roboto;
    font-size: var(--Font-Font-Size-h4, 14px) !important;
  }
  .security-settings-head {
    font-size: var(--Font-Font-Size-h6, 14px) !important;
  }
  .account-recovery-head {
    font-size: 16px !important;
  }
  .card-tittle {
    font-size: 14px !important;
  }
  .buyer-contents-menu-name {
    font-size: 14px !important;
  }
  .main-title-size {
    font-size: 16px !important;
  }
  .settings-preference-head {
    font-size: 14px !important;
  }
  .payment-methods-head {
    font-size: var(--Font-Font-Size-h6, 14px) !important;
  }
  .access-faq-btn-text {
    font-size: 14px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/personal-details/PersonalDetails.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;AACT;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;EACP,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,wCAAwC;EACxC,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,kCAAkC;EAClC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,uBAAuB;AACzB;AACA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oDAAoD;EACpD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;AACA;;;;EAIE,oCAAoC;AACtC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,sCAAsC;IACtC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;;IAEE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;IACvB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;EACA;;IAEE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;EACA;;IAEE,qBAAqB;IACrB,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,gDAAgD;EAClD;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,kCAAkC;IAClC,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,kDAAkD;IAClD,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;EACA;;IAEE,oBAAoB;IACpB,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,oCAAoC;EACtC;EACA;IACE,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,sCAAsC;IACtC,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,6BAA6B;EAC/B;EACA;IACE,sCAAsC;IACtC,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;AACF;AACA;EACE;IACE,oCAAoC;EACtC;AACF;AACA;EACE;IACE,mBAAmB;IACnB,oDAAoD;EACtD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,oDAAoD;EACtD;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".personal-details-container {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 105.3125rem;\n  background: #f5f5f5;\n}\n.personal-details-title {\n  display: flex;\n  height: 90px;\n  padding: 2%;\n  align-items: center;\n  flex-shrink: 0;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Montserrat;\n  font-size: var(--Font-Font-Size-h5, 19px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border-bottom: 1px solid #d2d2d2;\n}\n.profile-image-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5%;\n}\n.profile-image-upload-buttons-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5%;\n  margin-top: 5%;\n}\n.upfront-percentage-col {\n  display: flex;\n  justify-content: space-between;\n}\n.buyer-contents-menu-card-row {\n  margin-left: 4%;\n}\n\n.buyer-contents-menu-card {\n  display: flex;\n  padding: 32px 21px 607px 21px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 11px;\n  flex-shrink: 0;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.buyer-contents-menu {\n  display: flex;\n  height: 60px;\n  padding: 14px 33px;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  width: 100%;\n}\n\n.buyer-contents-menu-name {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  width: 100% !important;\n  cursor: pointer;\n  font-size: 16px !important;\n}\n\n.buyer-contents-menu .ant-menu-item:hover,\n.buyer-contents-menu .ant-menu-item-selected {\n  background-color: transparent !important;\n  color: inherit !important;\n  cursor: default !important;\n  border-left: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n}\n.buyer-contents-menu-card-row .ant-col-6 {\n  max-width: 25% !important;\n}\n.personal-information-main-heading-div {\n  margin-top: 5%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.personal-information-main-heading {\n  color: #000;\n  font-family: Montserrat;\n  font-size: var(--Font-Font-Size-h4, 17px) !important;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  justify-content: center;\n}\n.avatar-col {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.floating-avatar {\n  display: flex;\n  height: 5rem;\n  padding: 2.6875rem 1.625rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  border-radius: 6.25rem;\n  background: #fff;\n  box-shadow: 2px 2px 20px 0px rgba(0, 0, 0, 0.16);\n}\n.your-details-text {\n  font-family: Roboto;\n  color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.upload-new-photo-card {\n  width: 100%;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  margin-top: 5%;\n  display: flex;\n  align-items: center;\n  padding: 20px;\n}\n\n.card-tittle {\n  font-family: Roboto;\n}\n\n.image-card-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 8rem;\n}\n\n.profile-image-section {\n  border-radius: 50%;\n  overflow: hidden;\n  border: 2px solid #e0e0e0;\n}\n.buyer-content-details {\n  margin-left: 4% !important;\n  position: sticky;\n  overflow-y: auto;\n  max-height: 78vh;\n}\n.profile-image {\n  width: 7rem !important;\n  height: 7rem !important;\n  flex-shrink: 0;\n}\n\n.upload-photo-content {\n  display: flex;\n  width: 100%;\n  /* margin-bottom: 2rem !important; */\n}\n\n.sample-parent .ant-upload-wrapper .ant-upload-select {\n  margin-bottom: 0.5rem;\n}\n.profile-delete-text {\n  font-family: Roboto;\n  color: #d2042d;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n  cursor: pointer;\n  margin-top: 10px;\n}\n.profile-image-section-remove {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.upload-instruction {\n  margin-top: 8px;\n  color: #9e9e9e;\n  font-size: 14px;\n}\n\n.sample-parent .ant-btn-icon {\n  display: none !important;\n}\n\n.parent-ant-button\n  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n  background: transparent !important;\n  color: inherit !important;\n  border-color: inherit !important;\n}\n\n.upload-profile-and-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.upload-below-text {\n  font-family: Roboto;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 0.8rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.profile-upload-btn {\n  font-family: Roboto;\n  display: flex;\n  padding: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  background: #f5f5f5;\n}\n\n.upload-btn-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.personal-details-card {\n  padding: 2rem;\n  flex-shrink: 0;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  margin-top: 4%;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.card-header h3 {\n  font-weight: bold;\n}\n\n.edit-button {\n  font-family: Roboto;\n  color: #d2042d;\n  border: none;\n  background: transparent;\n}\n.edit-button:hover,\n.edit-button:active,\n.edit-button:active {\n  border: none !important;\n  box-shadow: none !important;\n  background-color: none !important;\n}\n\n.details-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.details-row {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #f0f0f0;\n  padding-bottom: 8px;\n}\n\n.details-row-div {\n  display: flex;\n  padding-bottom: 1.5rem;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.details-row-headers {\n  font-family: Roboto;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.5rem;\n}\n\n.details-row-text {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.5rem;\n}\n.account-type-logo-col {\n  display: flex;\n  align-items: center;\n}\n.details-row-text:hover {\n  color: var(--Colors-Text-500, #0a0f0d) !important;\n}\n.contact-information-card {\n  padding: 2rem;\n  flex-shrink: 0;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  margin-top: 4%;\n}\n\n.address-card {\n  margin-top: 4%;\n  padding: 2rem;\n  flex-shrink: 0;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.account-information-card {\n  margin-top: 4%;\n  padding: 1rem;\n  flex-shrink: 0;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.account-row-headers {\n  font-family: Roboto;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.5rem;\n}\n.website-url {\n  color: var(--Colors-Primary-500, #d2042d) !important;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.membership-status-card {\n  margin-top: 4%;\n  padding: 2rem;\n  flex-shrink: 0;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.memebership-status-value {\n  color: #28a745;\n  text-align: right;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.5rem;\n}\n\n.subscription-plan-card {\n  margin-top: 4%;\n  padding: 2rem;\n  flex-shrink: 0;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  display: none;\n}\n\n.subscription-plan-head {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h6, 1.1875rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5rem;\n}\n\n.manage-subscription-link-container {\n  display: contents;\n  justify-content: center;\n  justify-items: center;\n}\n\n.manage-subscription-link {\n  font-family: Roboto;\n  color: var(--Colors-Primary-500, #d2042d) !important;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n\n.security-settings-head {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h6, 1.1875rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5rem;\n}\n\n.account-recovery-card {\n  margin-top: 4%;\n  padding: 2rem;\n  flex-shrink: 0;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.account-recovery-head {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h6, 1.1875rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5rem;\n}\n\n.notification-preference-card {\n  margin-top: 4%;\n  padding: 2rem;\n  flex-shrink: 0;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n.settings-preference-head {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h6, 16px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5rem;\n}\n.payment-methods-card {\n  margin-top: 4%;\n  padding: 2rem;\n  flex-shrink: 0;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n.payment-methods-head {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h6, 1.1875rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5rem;\n}\n.payment-download-text {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n}\n.help-support-card {\n  margin-top: 4%;\n  padding: 2rem;\n  flex-shrink: 0;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n.payment-methods-head {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h6, 16px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5rem;\n}\n.access-faq-btn-text {\n  font-family: Roboto;\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n.details-cancel-btn {\n  display: flex;\n  padding: 0.5rem 1.25rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  background: #eee;\n}\n.details-cancel-btn-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.details-save-btn {\n  display: flex;\n  padding: 0.5rem 1.25rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  background: #d2042d;\n}\n.details-save-btn-text {\n  color: #fff;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.profile-upload-cancel-btn {\n  display: flex;\n  padding: 0.5rem 1.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  background: #e0e0e0;\n}\n.profile-upload-cancel-btn-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.personal-details-col {\n  display: flex;\n  flex-direction: column;\n  width: 50% !important;\n}\n.profile-upload-save-btn {\n  display: flex;\n  padding: 0.5rem 1.25rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  background: #d2042d;\n}\n.profile-upload-save-btn:hover {\n  background: #d2042d !important;\n}\n.profile-upload-save-btn-text {\n  color: #fff;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.terms-setup-card,\n.upfront-payment-card {\n  margin-top: 2.125rem;\n}\n.default-terms {\n  font-family: Roboto;\n  font-size: 1rem;\n  font-weight: 400;\n  margin-top: 2.125rem;\n}\n.navigate-to-terms {\n  margin-top: 0.5rem;\n}\n.default-terms-link {\n  font-family: Roboto;\n  text-decoration: underline;\n  color: #d2042d;\n  font-size: 1rem;\n  font-weight: 400;\n  margin-top: 0.5rem;\n}\n.edit-label {\n  font-family: Roboto;\n  color: #d2042d;\n  font-size: 1rem;\n  cursor: pointer;\n  margin-left: 0.2rem;\n  position: relative;\n  bottom: 0.2rem;\n}\n.edit-icon {\n  height: 24px;\n  cursor: pointer;\n  margin-left: 1.2rem;\n}\n.upfront-percent {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 1rem;\n  padding-left: 0.8rem;\n}\n.percent-symbol {\n  font-family: Roboto;\n  top: 1rem;\n  position: relative;\n  font-size: 1rem;\n  font-weight: 700;\n}\n.upfront-cancel-btn,\n.upfront-save-btn {\n  font-weight: 500;\n  border: none;\n}\n.upfront-cancel-btn {\n  background: #e5e5e5 !important;\n  color: #000 !important;\n}\n.upfront-save-btn {\n  color: #fff !important;\n  background-color: #d2042d !important;\n}\n\n.personal-details-avatar {\n  background: #d2042d;\n  color: #fff;\n}\n\n.profile-edit-btn {\n  display: flex;\n  gap: 0.5rem;\n}\n.my-billboard-datepicker\n  ~ .ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-today\n  .ant-picker-cell-inner::before {\n  border: 1px solid #d2042d !important;\n}\n.my-billboard-datepicker.ant-picker-outlined:hover {\n  border-color: #000 !important;\n}\n.personal-details-buttons-row {\n  display: flex;\n  margin-top: 1rem;\n  gap: 0.5rem;\n  justify-content: flex-end;\n}\n.remove-profile-picture {\n  font-family: Roboto;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000;\n}\n.remove-profile-buttons-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 20px;\n}\n.confirmation-remove-profile-row {\n  margin-top: 10px;\n}\n.confirmation-remove-profile-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-400, #3b3f3d);\n}\n.remove-profile-button {\n  height: 35px !important;\n  background-color: #d2042d !important;\n}\n.remove-profile-button-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #fff;\n}\n.remove-profile-button:hover {\n  background-color: #d2042d !important;\n}\n.profile-delete-cancel-button {\n  height: 35px !important;\n  background: #e0e0e0;\n}\n.profile-delete-cancel-button:hover {\n  background: #e0e0e0 !important;\n}\n.profile-delete-cancel-button-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000;\n}\n.details-label-col {\n  width: 50%;\n}\n@media (max-width: 1024px) {\n  .buyer-content-details {\n    margin-left: 4% !important;\n    position: sticky;\n    overflow-y: scroll;\n    max-height: 82vh;\n  }\n  .buyer-contents-menu-card-row {\n    gap: 4% !important;\n  }\n}\n@media (max-width: 1440px) {\n  .buyer-content-details {\n    margin-left: 4% !important;\n    position: sticky;\n    overflow-y: scroll;\n    max-height: 75vh;\n  }\n  .buyer-contents-menu-card-row {\n    gap: 4% !important;\n  }\n}\n\n@media (min-width: 321px) and (max-width: 375px) {\n  .upload-new-photo-card {\n    width: 90%;\n    margin-left: 17px;\n  }\n  .personal-details-card {\n    width: 90%;\n    margin-left: 17px;\n  }\n  .contact-information-card {\n    width: 90%;\n    margin-left: 17px;\n  }\n  .address-card {\n    width: 90%;\n    margin-left: 17px;\n  }\n  .back-button {\n    font-size: 12px;\n    padding: 5px 10px;\n    width: auto;\n  }\n  .personal-details-col {\n    overflow-x: scroll !important;\n  }\n  .details-row-text {\n    font-size: 0.9rem !important;\n  }\n  .personal-information-main-heading {\n    color: #000;\n    font-family: Montserrat;\n    font-size: var(--Font-Font-Size-h4, 20px);\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  .account-information-card {\n    width: 90%;\n    margin-left: 17px;\n  }\n  .membership-status-card {\n    width: 90%;\n    margin-left: 17px;\n  }\n  .account-row-headers {\n    font-size: 0.9rem;\n  }\n  .details-row-headers {\n    font-family: Roboto;\n    color: var(--Colors-Text-200, #8e9190);\n    font-size: 0.9rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 1.5rem;\n  }\n  .account-recovery-card {\n    width: 90%;\n    margin-left: 17px;\n  }\n  .notification-preference-card {\n    width: 90%;\n    margin-left: 17px;\n  }\n  .help-support-card {\n    width: 90%;\n    margin-left: 17px;\n  }\n  .terms-setup-card,\n  .upfront-payment-card {\n    width: 90%;\n    margin-left: 17px;\n  }\n}\n\n@media (min-width: 376px) and (max-width: 425px) {\n  .personal-information-main-heading {\n    color: #000;\n    font-family: Montserrat;\n    font-size: var(--Font-Font-Size-h4, 20px);\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  .upload-new-photo-card {\n    width: 90%;\n    margin-left: 20px;\n  }\n  .personal-details-card {\n    width: 90%;\n    margin-left: 20px;\n  }\n  .contact-information-card {\n    width: 90%;\n    margin-left: 20px;\n  }\n  .address-card {\n    width: 90%;\n    margin-left: 20px;\n  }\n  .account-information-card {\n    width: 90%;\n    margin-left: 20px;\n  }\n  .membership-status-card {\n    width: 90% !important;\n    margin-left: 20px !important;\n  }\n  .account-recovery-card {\n    width: 90%;\n    margin-left: 20px;\n  }\n  .notification-preference-card {\n    width: 90%;\n    margin-left: 20px;\n  }\n  .help-support-card {\n    width: 90%;\n    margin-left: 20px;\n  }\n  .back-button {\n    font-size: 12px;\n    padding: 5px 10px;\n    width: auto;\n  }\n  .terms-setup-card,\n  .upfront-payment-card {\n    width: 90%;\n    margin-left: 17px;\n  }\n  .personal-details-col {\n    overflow-x: scroll;\n  }\n}\n@media (min-width: 426px) and (max-width: 768px) {\n  .upload-new-photo-card {\n    width: 90%;\n    margin-left: 35px;\n  }\n  .personal-information-main-heading {\n    color: #000;\n    font-family: Montserrat;\n    font-size: var(--Font-Font-Size-h4, 23px);\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  .personal-details-card {\n    width: 90%;\n    margin-left: 35px;\n  }\n  .contact-information-card {\n    width: 90%;\n    margin-left: 35px;\n  }\n  .address-card {\n    width: 90%;\n    margin-left: 35px;\n  }\n  .account-information-card {\n    width: 90%;\n    margin-left: 35px;\n  }\n  .membership-status-card {\n    width: 90% !important;\n    margin-left: 35px !important;\n  }\n  .account-recovery-card {\n    width: 90%;\n    margin-left: 35px;\n  }\n  .notification-preference-card {\n    width: 90%;\n    margin-left: 35px;\n  }\n  .help-support-card {\n    width: 90%;\n    margin-left: 35px;\n  }\n  .back-button {\n    font-size: 17px;\n    padding: 2px 10px;\n    width: auto;\n  }\n  .terms-setup-card,\n  .upfront-payment-card {\n    width: 90% !important;\n    margin-left: 35px !important;\n  }\n}\n@media (min-width: 320px) and (max-width: 844px) {\n  .buyer-contents-menu-card-row {\n    margin: 0px !important;\n    width: 100%;\n    overflow-y: scroll;\n    max-height: 100%;\n  }\n\n  .buyer-content-details {\n    margin: 0 !important;\n    padding: 1.1rem !important;\n    max-height: 100%;\n  }\n  .personal-details-container {\n    height: 100% !important;\n    /* position: fixed; */\n    overflow-y: scroll;\n  }\n\n  .buyer-contents-menu {\n    display: flex;\n    width: 100%;\n    padding: 0.5rem 1.25rem;\n    align-items: center;\n    gap: 0.5rem;\n    flex-shrink: 0;\n    border-radius: 0.625rem;\n    background: #fff;\n    box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);\n  }\n  .buyer-contents-menu-name {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .buyer-contents-menu-card {\n    display: flex;\n    /* padding: 0px 21px 607px 21px; */\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem !important;\n    flex-shrink: 0;\n    background: none;\n    box-shadow: none;\n  }\n  .personal-details-title {\n    height: 0px;\n    border-bottom: none;\n    margin-bottom: 1rem !important;\n    padding: 0 !important;\n  }\n  .personal-information-main-heading-div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n@media (min-width: 0px) and (max-width: 320px) {\n  .buyer-content-details {\n    position: sticky;\n  }\n  .profile-image {\n    width: 5rem !important;\n    height: 5rem !important;\n  }\n  .profile-upload-btn {\n    height: 2rem !important;\n  }\n  .upload-btn-text {\n    font-size: 13px !important;\n  }\n  .profile-delete-text {\n    font-size: 11px !important;\n  }\n  .details-row-text {\n    font-size: 0.9rem !important;\n  }\n\n  .upload-new-photo-card {\n    width: 90%;\n    border-radius: 10px;\n    background: #fff;\n    box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n    margin-top: 5%;\n    display: flex;\n    align-items: center;\n    padding: 20px;\n    margin-left: 1rem;\n  }\n  .personal-details-card {\n    width: 90%;\n    margin-left: 1rem;\n    padding: 1rem;\n  }\n  .account-recovery-card {\n    width: 90%;\n    margin-left: 1rem;\n  }\n  .contact-information-card {\n    width: 90%;\n    margin-left: 1rem;\n    padding: 1rem;\n  }\n  .address-card {\n    width: 90%;\n    margin-left: 1rem;\n    padding: 1rem;\n  }\n  .back-button {\n    font-size: 12px;\n    padding: 5px 10px;\n    width: auto;\n  }\n  .terms-setup-card,\n  .upfront-payment-card {\n    margin-top: 2.125rem;\n    width: 90%;\n    margin-left: 1rem;\n  }\n  .personal-information-main-heading {\n    color: #000;\n    font-family: Montserrat;\n    font-size: var(--Font-Font-Size-h4, 20px);\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  .personal-information-main-heading-div {\n    margin-top: 5%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-content: stretch;\n    align-items: flex-start;\n    margin-inline-start: 10px !important;\n  }\n  .card-tittle {\n    font-family: Roboto;\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-family: Roboto;\n    font-size: 0.9rem;\n    font-style: normal;\n    font-weight: 550;\n    line-height: normal;\n  }\n  .details-row-headers {\n    color: var(--Colors-Text-200, #8e9190);\n    font-size: 0.8rem !important;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 1.5rem;\n  }\n  .personal-details-col {\n    width: 50% !important;\n    overflow-x: scroll !important;\n  }\n  .details-row-text {\n    color: var(--Colors-Text-500, #0a0f0d);\n    text-align: right;\n    font-size: 0.8rem !important;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 1.5rem;\n  }\n  .website-url {\n    font-size: 0.9rem;\n  }\n  .account-information-card {\n    width: 90%;\n    margin-left: 15px;\n    padding: 1rem;\n  }\n  .membership-status-card {\n    width: 90%;\n    margin-left: 15px;\n    padding: 1rem;\n  }\n  .notification-preference-card {\n    width: 90%;\n    margin-left: 15px;\n    padding: 1rem;\n  }\n  .account-row-headers {\n    font-size: 0.9rem;\n  }\n  .your-details-text {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n  .swith-button .ant-switch {\n    transform: scale(0.6);\n  }\n  .security-settings-head {\n    font-size: 18px;\n    font-weight: 600px;\n  }\n  .manage-subscription-link {\n    font-size: 14px;\n  }\n  .account-recovery-head {\n    font-size: 18px;\n    font-weight: 600px;\n  }\n  .settings-preference-head {\n    font-size: 18px;\n    font-weight: 600px;\n  }\n  .help-support-card {\n    width: 90%;\n    margin-left: 15px;\n    padding: 1rem;\n  }\n}\n@media (min-width: 426px) and (max-width: 768px) {\n  .personal-information-main-heading-div {\n    margin-inline-start: 28px !important;\n  }\n}\n@media (max-width: 768px) {\n  .personal-information-main-heading {\n    font-family: Roboto;\n    font-size: var(--Font-Font-Size-h4, 14px) !important;\n  }\n  .security-settings-head {\n    font-size: var(--Font-Font-Size-h6, 14px) !important;\n  }\n  .account-recovery-head {\n    font-size: 16px !important;\n  }\n  .card-tittle {\n    font-size: 14px !important;\n  }\n  .buyer-contents-menu-name {\n    font-size: 14px !important;\n  }\n  .main-title-size {\n    font-size: 16px !important;\n  }\n  .settings-preference-head {\n    font-size: 14px !important;\n  }\n  .payment-methods-head {\n    font-size: var(--Font-Font-Size-h6, 14px) !important;\n  }\n  .access-faq-btn-text {\n    font-size: 14px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
